module.exports = __webpack_public_path__ + "img/7.445ac3c5.png";